module.exports = __webpack_public_path__ + "img/icon2.69f8e1d7.png";